/* eslint-disable @typescript-eslint/no-explicit-any */
// This goes above everything else to ensure polyfills are loaded correctly.
// IMPORT ORDER MATTERS HERE
import '@js-joda/timezone/dist/js-joda-timezone-1970-2030';
// IMPORT ORDER MATTERS HERE
import 'utils/protos';
// IMPORT ORDER MATTERS HERE
import 'utils/consumerProto';

import * as Analytics from 'utils/Analytics';
import { Location } from 'history';
import { StoreType } from '@tock/shared/utils/connect';
import { closeMenu } from 'actions/UIActions';
import { currentMetroAreaSelector } from 'selectors/metroAreaSelectors';
import { fetchConfig } from 'actions/AppActions';
import { getDomain } from 'utils/domainUtils';
import { getSettings } from 'settings/AppSettings';
import { localEnhancedStores, sessionEnhancedStores } from 'utils/enhancedStores';
import { searchPage } from 'actions/ConsumerPageActions';
import Application from './Application';
import _ from 'lodash';
import clientBootstrap from './clientBootstrap';
import rootReducer from 'state';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

const appSettings = getSettings(__ENV__);

const state = (window as any).$REDUX_STATE as StoreType;

const analytics = Analytics.initialize(appSettings.GA_KEY, appSettings.GA4_KEY, {
  businessUaProperty: state.app.config?.business?.googleAnalyticsWebPropertyUa || undefined,
  businessGa4StreamId: state.app.config?.business?.googleAnalyticsWebProperty_4 || undefined,
});
window.analytics = analytics;

const store = clientBootstrap.initializeApp(
  appSettings,
  rootReducer,
  {
    sessionEnhancedStores,
    localEnhancedStores,
  },
  (store: any, location: Location) => {
    if (analytics) {
      analytics.transitionToPage(location as any); // weird type error
    }
    store.dispatch(closeMenu());
  }
);

// Provide the store on the window for modals and easy debugging.
(window as any).store = store;

const app = store.getState().app;
const selectedMetro = currentMetroAreaSelector(store.getState());
if (app.isInitialized) {
  clientBootstrap.renderApp(store, Application);
} else {
  const domain = getDomain(location.pathname);
  Promise.all([
    store.dispatch(fetchConfig(domain)),
    store.dispatch(
      searchPage(
        location.pathname,
        { type: 'EXPLORETOCK' },
        appSettings.PREVIEW_MODE === 'preview',
        selectedMetro?.id
      )
    ),
  ])
    .then(() => {
      setTimeout(() => {
        clientBootstrap.renderApp(store, Application);
      }, 0);
    })
    .catch(_.noop);
}
